import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Table, Tooltip, InputNumber } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import ProdutoFrame from './ProdutoFrame';
import axios from "axios";

const { Item: ItemForm } = Form;
const { Column } = Table;

export default class ProdutoTipoAnaliseForm extends Component {
  state = {
    registro: {
      pta_idf_tipo_analise: { key: '0' },
      pta_idf_produto: { key: '0' },
      pta_dias_validade: 0,
      pta_qtde_analisar: 0,
      pta_embalagem: '',
    },

    editando: false,
    tipoAnaliseSelect: [],
    listaItens: [],
    carregandoForm: false,
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      // console.log('componentDidUpdate', this.props)
      this.setState({
        registro: this.props.registroSelecionado.dados,
        listaItens: this.props.registroSelecionado.listaItens,
        editando: this.props.registroSelecionado.editando
      }, () => {
        this.buscaTiposAnalises();
      });
    }
  }

  onOK = () => {
    if ((!this.state.registro.pta_idf_tipo_analise) || (this.state.registro.pta_idf_tipo_analise === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Tipo de Análise' });
      return;
    }

    const reg = {
      editando: this.state.editando,
      pta_idf_produto: this.state.registro.pta_idf_produto.key,
      pta_dias_validade: this.state.registro.pta_dias_validade,
      pta_qtde_analisar: this.state.registro.pta_qtde_analisar,
      pta_embalagem: this.state.registro.pta_embalagem,
      listaItens: this.state.listaItens,
    }

    this.props.onSalvarClick(reg);
  };



  onNovoDesconto = () => {
    if ((!this.state.registro.pta_idf_tipo_analise) || (this.state.registro.pta_idf_tipo_analise.key === '0') || (this.state.registro.pta_idf_tipo_analise.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Tipo de Análise', });
      return;
    }
    if ((!this.state.registro.pta_idf_produto) || (this.state.registro.pta_idf_produto.key === '0') || (this.state.registro.pta_idf_produto.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Produto', });
      return;
    }

    this.state.listaItens.push({
      pta_idf_tipo_analise: this.state.registro.pta_idf_tipo_analise.tai_idf,
      pta_seq_tipo_analise: this.state.registro.pta_idf_tipo_analise.tai_seq,
      pta_idf_produto: this.state.registro.pta_idf_produto.key,
      pta_dias_validade: this.state.registro.pta_dias_validade,
      pta_qtde_analisar: this.state.registro.pta_qtde_analisar,
      pta_embalagem: this.state.registro.pta_embalagem,
      ta_descricao: this.state.registro.pta_idf_tipo_analise.ta_descricao,
      tai_descricao: this.state.registro.pta_idf_tipo_analise.tai_descricao,
    });

    this.setState({
      pta_idf_tipo_analise: { key: '' },
      listaItens: this.state.listaItens
    });
  };

  onExcluirProdutoClick = (reg) => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este produto?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        const listaItens = [...this.state.listaItens];
        const index = listaItens.findIndex(registro => registro.pta_idf_tipo_analise === reg.pta_idf_tipo_analise && registro.pta_seq_tipo_analise === reg.pta_seq_tipo_analise);
        listaItens.splice(index, 1);
        this.setState({
          listaItens,
        });
      }
    })
  }

  renderAcoesProdutos = (registro) => {
    return (
      <Tooltip title="Excluir" placement="top">
        <Button className="botoesModalFormExcluir" onClick={() => this.onExcluirProdutoClick(registro)} icon="delete" />
      </Tooltip>
    );
  };


  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
  };

  onChangeTipoAnalise = event => {
    const { registro } = this.state;
    const value = event.target.value;
    const id = event.target.id;
    const state = {};
    const iInd = this.state.tipoAnaliseSelect.findIndex(registro => String(registro.key) === String(value.key));
    registro[id] = {
      key: value.key,
      label: value.label,
      tai_idf: String(this.state.tipoAnaliseSelect[iInd].tai_idf),
      tai_seq: String(this.state.tipoAnaliseSelect[iInd].tai_seq),
      ta_descricao: String(this.state.tipoAnaliseSelect[iInd].ta_descricao),
      tai_descricao: String(this.state.tipoAnaliseSelect[iInd].tai_descricao),
    };
    this.setState({
      [id]: {
        key: value.key,
        label: value.label,
        tai_idf: String(this.state.tipoAnaliseSelect[iInd].tai_idf),
        tai_seq: String(this.state.tipoAnaliseSelect[iInd].tai_seq),
        ta_descricao: String(this.state.tipoAnaliseSelect[iInd].ta_descricao),
        tai_descricao: String(this.state.tipoAnaliseSelect[iInd].tai_descricao),
      }
    });
  }

  onChangeProduto = event => {
    const { registro } = this.state;
    registro['pta_idf_produto'] = event.pta_idf_produto;
    this.setState(event);
  }

  onInputChangeDiasVal = event => {
    const value = event;
    const id = 'pta_dias_validade';
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
  }

  onInputChangeQtdeAnalisar = event => {
    const value = event;
    const id = 'pta_qtde_analisar';
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
  }

  buscaTiposAnalises = (value) => {
    this.setState({ tipoAnaliseSelect: [] })
    const { gtp_idf } = this.state.registro;
    axios.get('/tiposAnalises/listaItens', {
    }).then(response => {
      const { data } = response;
      const tipoAnaliseSelect = data.map(regList => {
        return {
          key: regList.tai_idf + '_' + regList.tai_seq,
          label: regList.ta_descricao + ' - ' + regList.tai_descricao,
          tai_idf: regList.tai_idf,
          tai_seq: regList.tai_seq,
          ta_descricao: regList.ta_descricao,
          tai_descricao: regList.tai_descricao,
        }
      });

      this.setState({
        tipoAnaliseSelect,
      })

    }).catch(error => {
      console.error(error.response);
    })
  }







  render() {
    const { onCancelarClick, carregando, visivel, editando } = this.props;
    const { pta_idf_tipo_analise, pta_idf_produto, pta_dias_validade, pta_qtde_analisar, pta_embalagem } = this.state.registro;
    const { carregandoForm, tipoAnaliseSelect, listaItens } = this.state;

    // console.log('ProdutoTipoAnaliseForm: ', this.state)

    return (
      <Modal
        title={editando ? "Edição de Produtos / Tipo Análise" : "Cadastro de Produtos / Tipo Análise"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"50%"}
        style={{ top: 30 }}
      >
        <Form>
          <Row style={{ marginBottom: 20 }} >

            <Col xs={24} style={{}}>
              <ProdutoFrame
                label="Produto"
                id="pta_idf_produto"
                value={pta_idf_produto}
                width={"100%"}
                onChange={this.onChangeProduto}
                descricaoPrimeiroItem="Selecione um Produto"
              />
            </Col>

            <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 10 }}>
              <span>Dias Validade</span>
              <InputNumber
                ref="Input"
                id={pta_dias_validade}
                value={pta_dias_validade}
                onChange={this.onInputChangeDiasVal}
                min={0}
                max={999999}
                maxLength={6}
                style={{ width: '100%' }}
              />
            </Col>

            <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 10 }}>
              <span>Qtde Analisar</span>
              <InputNumber
                ref="Input"
                id={pta_qtde_analisar}
                value={pta_qtde_analisar}
                onChange={this.onInputChangeQtdeAnalisar}
                min={0}
                max={999999}
                maxLength={6}
                style={{ width: '100%' }}
              />
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -23 }}>
              <span>Embalagem</span>
              <InputForm
                id="pta_embalagem"
                ref="pta_embalagem"
                maxLength={30}
                onChange={this.onChange}
                value={pta_embalagem}
              />
            </Col>

            <div>

              <Col xs={24} style={{ marginTop: 20 }}>
                <div className="div-subTitulo">
                  <span style={{ marginLeft: 10, fontWeight: "bold", fontSize: 17 }}>
                    Tipos de Análise do Produto
                  </span>
                </div>

                <Col xs={24} style={{}}>
                  <span>Tipo de Análise</span>
                  <InputForm
                    type="select"
                    id="pta_idf_tipo_analise"
                    ref="pta_idf_tipo_analise"
                    value={pta_idf_tipo_analise}
                    placeholder="Selecione"
                    onChange={this.onChangeTipoAnalise}
                    data={tipoAnaliseSelect}
                    validator={value => Boolean(value)}
                    style={{ width: "100%" }}
                    showSearch
                  />
                </Col>
                <Col xs={24} style={{ marginTop: -20 }}>
                  <Button
                    htmlType="button"
                    onClick={this.onNovoDesconto}
                    icon="plus"
                    className="botoesModalForm2x"
                  > Adicionar
                  </Button>
                </Col>
              </Col>

              <Col xs={24} style={{ marginTop: 25 }}>
                <Table
                  loading={{
                    spinning: carregandoForm,
                    tip: 'Carregando. Aguarde...',
                    size: "large"
                  }}
                  dataSource={listaItens}
                  pagination={false}
                  rowKey={(listaItens => listaItens.pta_idf_tipo_analise + '-' + listaItens.pta_seq_tipo_analise)}
                >
                  <Column
                    key="ta_descricao"
                    dataIndex="ta_descricao"
                    title="Tipo Análise"
                    width={"40%"}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="tai_descricao"
                    dataIndex="tai_descricao"
                    title="Descrição"
                    width={"40%"}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="acoes"
                    title=""
                    render={this.renderAcoesProdutos}
                    width={"20%"}
                    align="center"
                    className="listaCadastro"
                  />
                </Table>
              </Col>

            </div>

          </Row>


          <ItemForm>
            <Row>
              <Col xs={24}>
                <Button
                  htmlType="button"
                  loading={carregando}
                  onClick={this.onOK}
                  className="botoesModalForm"
                >
                  Salvar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="botoesModalFecharForm"
                >
                  Cancelar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProdutoTipoAnaliseForm.js